import { FieldRow, Form } from '@/components';
import { Col } from 'antd';
import { useField, useFormikContext } from 'formik';
import { useEffect } from 'react';
import {
  getCustomReportAvailableColumns,
  getCustomReportType,
} from './customReportColumnsConfigurations';
import { ManageReportExcelTemplatesButton } from './ManageReportExcelTemplatesButton';
import { useReportExcelTemplateLookupSource } from './useReportExcelTemplateLookupSource';
import styles from './FormCustomReport.module.scss';

interface Props {
  name: string;
  className?: string;
}

export function FormCustomReportTemplateOptions(props: Props) {
  const { name, className } = props;
  const { source: reportTemplateSource, sourceId: reportTemplateSourceId } =
    useReportExcelTemplateLookupSource();
  const { setFieldValue } = useFormikContext();
  const [{ value }] = useField(name);

  useEffect(() => {
    const type = getCustomReportType(value);
    const columns = getCustomReportAvailableColumns(value);

    setFieldValue('options.type', type);
    setFieldValue('columns', columns);
  }, [setFieldValue, value]);

  return (
    <FieldRow className={className} justify="start">
      <Col xs={18} md={12}>
        <Form.AsyncSelect
          key={reportTemplateSourceId}
          dataSource={reportTemplateSource}
          name={name}
          preload
        />
      </Col>
      <Col className={styles.manageTemplate} span={2}>
        <ManageReportExcelTemplatesButton className="pt-2" />
      </Col>
    </FieldRow>
  );
}
